<!--
动画流程:
1. mark, poem, poet 在进入窗口范围后分别以 1s 的速度从下向上淡入
2. postmark 在进入窗口范围 0.5s 后以 1s 的速度从左向右淡入
-->
<template>
  <div id="js-tree" :class="$style.tree">
    <div id="js-tree-wrap" :class="$style.tree_wrap">
      <div id="js-tree-mark" :class="$style.mark">
        <div :class="[$style.mark_wrap, 'app-fadeInUp']" />
      </div>
      <div id="js-tree-poem" :class="$style.poem">
        <div class="app-fadeInUp">
          <h2>一棵树的成长</h2>
          <p>如果把加入极致游戏看做是一棵树的成长，</p>
          <p>那么志同道合是树根；</p>
          <p>个人目标与公司目标一致是树干；</p>
          <p>尊重差异是树枝；</p>
          <p>快乐与成长则是果实。</p>
        </div>
      </div>
      <div id="js-tree-poet" :class="$style.poet">
        <div class="app-fadeInUp">一叶 （创始人）</div>
      </div>
      <div id="js-tree-postmark" :class="$style.postmark">
        <div :class="[$style.postmark_wrap, 'app-fadeInRight']" />
      </div>
    </div>
  </div>
</template>

<script>
import aboutMixins from '@/assets/js/aboutMixins'

export default {
  mixins: [aboutMixins],
  data() {
    return {
      name: 'tree',
      animateScenesData: [
        'mark',
        'poem',
        'poet',
        { title: 'postmark', direction: 'Right' },
      ],
    }
  },
}
</script>

<style lang="less" module>
.tree {
  z-index: 1;
  position: relative;
  margin-top: -1.82rem;

  &_wrap {
    .size(16.77rem, 7.32rem);
    position: relative;
    margin: -1.82rem auto 0;
    background: url('./images/tree-bg.png') no-repeat;
    background-size: 100% 100%;
    font-size: 0.2rem;
    color: #fff;
    user-select: none;
  }
}

.mark {
  position: absolute;
  top: 1.64rem;
  left: 15.31rem;

  &_wrap {
    .size(0.7rem, 0.66rem);
    background: url('./images/tree-mark.png') no-repeat;
    background-size: 100% 100%;
  }
}

.poem {
  position: absolute;
  top: 2.4rem;
  left: 11.16rem;

  h2 {
    .size(1.94rem, 0.32rem);
    .text-hide();
    margin-bottom: 0.25rem;
    background: url('./images/tree-title.png') no-repeat;
    background-size: 100% 100%;
  }

  p {
    font-weight: 700;
    line-height: 1.6;
  }
}

.poet {
  position: absolute;
  top: 5.04rem;
  left: 14.65rem;
}

.postmark {
  position: absolute;
  top: 4.64rem;
  left: 9.64rem;

  &_wrap {
    .size(2.61rem, 1.18rem);
    background: url('./images/tree-postmark.png') no-repeat;
    background-size: 100% 100%;
  }

  :global {
    .app-fadeInRight-active {
      animation-delay: 0.5s;
    }
  }
}
</style>
